module.exports = __webpack_public_path__ + "static/media/infoProblems.538fea78.png";